import { render, staticRenderFns } from "./TopupMessaging.vue?vue&type=template&id=00d2226d&scoped=true&"
import script from "./TopupMessaging.vue?vue&type=script&lang=js&"
export * from "./TopupMessaging.vue?vue&type=script&lang=js&"
import style0 from "./TopupMessaging.vue?vue&type=style&index=0&id=00d2226d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d2226d",
  null
  
)

export default component.exports